import React from 'react';
import { withStyles } from 'material-ui/styles';
import SimpleDialog from '/components/FormComponents/Dialog';

const styles = { };

const TC = `
By signing this application, I/We certify the above information supplied is true and correct to the best of my/our
knowledge and belief. Privacy Act 1988: The Applicant and each Owner named above hereby irrevocably authorises Amazy
Investment Pty Ltd its servants and agents to make such enquiries as they deem necessary to investigate their credit
worthiness from time to time, including the making of enquiries with persons nominated as trade references, the bankers
of the Applicant, any credit provider or Credit Reporting Agency and including personal credit and consumer credit
information and LandData/property inquiries and name searches (hereinafter called “the sources”). The Applicant and
each Owner hereby authorises the sources to disclose to Amazy Investment Pty Ltd such information concerning the
Applicant and each Owner which is within their possession. I/we further grant to any source from which Amazy Investment
Pty Ltd has requested information about applicant(s), the authorisation to release such information to Amazy Investment
Pty Ltd. The Applicant and each Owner agrees that the information provided in this application concerning the Applicant
and each Owner and any relevant trading information arising from any dealings between Amazy Investment Pty Ltd and
the Applicant and each Owner may be disclosed to a Credit Reporting Agency or any other interested person, subject to
Amazy Investment Pty Ltd’s Privacy Policy which can be obtained upon request. You authorise Amazy Investment Pty Ltd to
complete any incomplete sections of this form verbally or via electronic communication with You.
`

class TermsConditions extends React.Component {
  render = () => {
    return (
      <SimpleDialog buttonLabel='View T&C' title='Terms and Conditions' content={TC}/>
    );
  };
}

export default withStyles(styles)(TermsConditions);



// WEBPACK FOOTER //
// ./src/components/TermsConditions/index.js